import { Hotkey } from "../../../../../ui/hotkey/component.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region src/internal/skins/shared/skins/shared/live-playback-hotkeys.tsx
/** @jsxImportSource react */
function LivePlaybackHotkeys({ disabled = false } = {}) {
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "Space",
			action: "togglePaused"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "k",
			action: "togglePaused"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "m",
			action: "toggleMuted"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "ArrowUp",
			action: "volumeStep"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "ArrowDown",
			action: "volumeStep"
		})
	] });
}
//#endregion
export { LivePlaybackHotkeys };

//# sourceMappingURL=live-playback-hotkeys.js.map